import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    vouchers: [],
    transactions: [],
    voucher: {},
    paginator: [],
    loading: false,
    editMode: false,
    showDelete: false,
    errorMsg: '',
    errors: {}
};

const voucherSlice = createSlice({
    name: 'vouchers',
    initialState,
    reducers: {
        setVouchers: (state, action) => {
            state.vouchers = action.payload;
        },
        setVoucher: (state, action) => {
            state.voucher = action.payload;
        },
        setTransactions: (state, action) => {
            state.transactions = action.payload;
        },
        setPaginator: (state, action) => {
            state.paginator = action.payload;
        },
        setEditMode: (state, action) => {
            state.editMode = action.payload;
        },
        setShowDelete: (state, action) => {
            state.showDelete = action.payload;
        },
        getErrors: (state, action) => {
            state.errorMsg = action.payload.errorMsg;
            state.errors = action.payload.errors;
        },
        clearErrors: (state) => {
            state.errorMsg = '';
            state.errors = '';
        },
        loading: (state, action) => {
            state.loading = action.payload;
        }
    },
});

export const { loading, setVouchers, setVoucher, setTransactions, setPaginator, setEditMode, setShowDelete, clearErrors, getErrors } = voucherSlice.actions;
export default voucherSlice.reducer;
